module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bd7f87fab548492fc7bb81e2a1fe5681.png";